import {observable} from 'mobx';
import GenericFormStore from '../../../stores/FormStore';
import userStore from '../../../stores/UserStore';
import appStore from '../../app/store';
import {customEvent} from '../../../utils/analyticsUtil';
import {actions, category, events} from '../../../constants/enums';

class PricingStore extends GenericFormStore {
    @observable form = this.initForm();

    initForm = () => {
        return {
            fields: {
                studentNum: {
                    value: '',
                    error: '',
                    rule: 'required'
                },
                phone: {
                    value: userStore.user.phone || '',
                    error: '',
                    rule: 'phone'
                }
            },
            meta: {
                isValid: false,
                error: null
            }
        };
    };

    formSubmit = (data) => {
        // TODO: api form submit call
        console.log(data);
        customEvent(events.CustomEvent, {category: category.Pricing, action: actions.SubmitPricingBanner, label: data.studentNum});
        appStore.createAlertFromMessageId('success', 'pricing.modal.success', '', 4000);
    }
}

const pricingStore = new PricingStore();
export default pricingStore;
